
<template>
  <svg  t="1728368404268" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7976" xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200"><path d="M929.9 563.8L567.6 201.4c-10.8-10.8-25.5-17-40.8-17.2L226.1 181c-21.2-0.2-38.6 16.7-38.8 37.9l-3.8 308.5c-0.2 15.8 6 31 17.1 42.1l361.8 361.8c22.9 22.9 60 22.9 82.8 0l284.7-284.7c22.9-22.9 22.9-60 0-82.8zM278.2 310.2c-23.4 0-42.4-19-42.4-42.4s19-42.4 42.4-42.4 42.4 19 42.4 42.4-19 42.4-42.4 42.4z" p-id="7977"></path></svg>
</template>

<script >
export default {
  name: 'couponIcon'
}
</script>
<style scoped>

</style>